import { PersonIcon, RocketIcon } from '@/assets/icons'
import BrandMark from '@components/BrandMark'
import React from 'react'
import { BrandLink, HeaderActions, HeaderContainer, HeaderContent, NavButton } from './Header.styles'
import { iconSizes } from '@/theme/tokens'

interface HeaderProps {
	onLogout?: () => void
	showBackButton?: boolean
	onBackClick?: () => void
	backButtonText?: string
	onMyTripsClick?: () => void
	onMyProfileClick?: () => void
	onAdminClick?: () => void
}

const Header: React.FC<HeaderProps> = ({
	onLogout,
	showBackButton = false,
	onBackClick,
	backButtonText = 'Back',
	onMyTripsClick,
	onMyProfileClick,
	onAdminClick,
}) => {
	return (
		<HeaderContainer>
			<HeaderContent>
				<BrandLink to="/trips" aria-label="Orbit — My Trips">
					<BrandMark />
				</BrandLink>
				<HeaderActions>
					{onAdminClick && (
						<NavButton variant="ghost" size="sm" onClick={onAdminClick}>
							Admin
						</NavButton>
					)}
					{onMyTripsClick && (
						<NavButton variant="ghost" size="sm" $collapse onClick={onMyTripsClick} aria-label="My Trips">
							<RocketIcon sx={{ fontSize: iconSizes.md }} />
							<span>My Trips</span>
						</NavButton>
					)}
					{onMyProfileClick && (
						<NavButton variant="ghost" size="sm" $collapse $neutral onClick={onMyProfileClick} aria-label="My Profile">
							<PersonIcon sx={{ fontSize: iconSizes.md }} />
							<span>My Profile</span>
						</NavButton>
					)}
					{showBackButton && onBackClick && (
						<NavButton variant="ghost" size="sm" onClick={onBackClick}>
							← {backButtonText}
						</NavButton>
					)}
					{onLogout && (
						<NavButton variant="ghost" size="sm" $neutral onClick={onLogout}>
							Logout
						</NavButton>
					)}
				</HeaderActions>
			</HeaderContent>
		</HeaderContainer>
	)
}

export default Header
